export const EVENT = {
  CURRENT_SCREEN: "page_visit",
  ADD_TO_CART: "add_to_cart",
  CHECKOUT: "checkout",
  PAYMENT_SUCCESS: "payment_success",
  PAYMENT_FAILURE: "payment_failure",
  LOGOUT: "logout",
  LOGIN: "login",
  SIGN_UP: "sign_up",
};
